import { render, staticRenderFns } from "./TabelaResultadosOrgaos.vue?vue&type=template&id=f11c1d1c&scoped=true&"
import script from "./TabelaResultadosOrgaos.vue?vue&type=script&lang=js&"
export * from "./TabelaResultadosOrgaos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11c1d1c",
  null
  
)

export default component.exports